<template>
  <div class="content1">
    <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px">
      <div class="box">
        <div class="title">
          基本信息
        </div>
        <el-form-item label="活动名称" class="fixedWidth" prop="title">
          <el-input v-model="form.title" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="活动时间" prop="start_time">
          <div>
            <el-date-picker
              v-model="form.start_time"
              type="date"
              class="inputWidth"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <span class="inputMargin">至</span>
            <el-date-picker
              v-model="form.end_time"
              type="date"
              class="inputWidth"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <!-- <div class="color">
              活动到期后将自动失效，失效后不可延长
            </div> -->
          </div>
        </el-form-item>
      </div>
      <div class="box">
        <div class="title">
          活动奖品
        </div>

        <el-form-item class="fixedWidth" label="优惠券">
          <div class="fontSize14 marginBottom" style="display: flex">
            <div class="inputMargin ">
              <el-button
                size="small"
                plain
                icon="el-icon-plus"
                @click="selectCoupon"
                >选择券</el-button
              >
              <div style="display:flex;flex-wrap: wrap; margin-top: 10px;">
                <!-- @close="delTagItem(id)" -->
                <el-tag
                  v-for="(tag, index) in sList"
                  :key="index"
                  style="margin-bottom:5px;margin-right:5px;"
                >
                  {{ tag.name }}
                  <span v-if="tag.choseNum != 1">
                    <span class="colorRed">×</span>
                    {{ tag.choseNum }} 张</span
                  >
                </el-tag>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="积分" class="fixedWidth">
          <div style="display:flex">
            送
            <div class="newInputWidth inputMargin">
              <el-input
                size="small"
                v-model="form.point"
                type="number"
                @blur="form.point = Number(form.point).toFixed(2)"
              ></el-input>
            </div>
            积分
          </div>
        </el-form-item>
        <el-form-item label="余额" class="fixedWidth">
          <div style="display:flex">
            送
            <div class="newInputWidth inputMargin">
              <el-input
                type="number"
                size="small"
                v-model="form.balance"
                @blur="form.balance = Number(form.balance).toFixed(2)"
              ></el-input>
            </div>
            余额
          </div>
        </el-form-item>
        <!-- <el-form-item label-width="80px">
          <el-checkbox-group v-model="checkList">
            <div class="flex marginBottom10">
              <el-checkbox label="0">
                <div class="fontSize14 marginBottom" style="display: flex">
                  <div class="fixedWidth60">
                    优惠券
                  </div>
                  <div class="inputMargin ">
                    <el-button
                      size="small"
                      plain
                      icon="el-icon-plus"
                      @click="selectCoupon"
                      >选择券</el-button
                    >
                    <div
                      style="display:flex;flex-wrap: wrap; margin-top: 10px;"
                    >
                      <el-tag
                        v-for="(tag, index) in sList"
                        :key="index"
                        closable
                        @close="delTagItem(id)"
                        style="margin-bottom:5px;margin-right:5px;"
                      >
                        {{ tag.name }}
                      </el-tag>
                    </div>
                  </div>
                </div>
              </el-checkbox>
            </div>
            <div class="flex marginBottom10">
              <el-checkbox label="">
                <div class="flex">
                  <div class="fixedWidth60">
                    积分
                  </div>
                  送
                  <div class="newInputWidth inputMargin">
                    <el-input size="small" v-model="form.point"></el-input>
                  </div>
                  积分
                </div>
              </el-checkbox>
            </div>
            <div class="flex marginBottom10">
              <el-checkbox label="">
                <div class="flex">
                  <div class="fixedWidth60">
                    余额
                  </div>
                  送
                  <div class="newInputWidth inputMargin">
                    <el-input size="small" v-model="form.balance"></el-input>
                  </div>
                  余额
                </div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </el-form-item> -->
      </div>
    </el-form>
    <!-- 底部提交 -->
    <div class="bottom">
      <el-button @click="$router.go(-1)">取消</el-button>
      <el-button type="primary" @click="submit('ruleForm')">确定</el-button>
    </div>
    <!-- 优惠券弹窗 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false" width="800px">
      <newSelectCommodityNum
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
      ></newSelectCommodityNum>
    </el-dialog>
  </div>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import multipleChoice from "@/components/commodity/multipleChoice.vue";
import { mapGetters } from "vuex";
import { storeSelect } from "@/api/employee";
import { vipList } from "@/api/vip";
import time from "@/utils/time";
import { addAttention, editAttention, detailAttention } from "@/api/market";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    newSelectCommodityNum,
    multipleChoice
  },
  data() {
    return {
      regs: "/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/;",
      initStatus: false,
      jude: this.$route.query.status,
      // 优惠券数据
      showSelecter: false, //优惠券选择器
      selected: [], //选择的优惠券
      sList: [], //已选择的优惠券列表
      // end
      checkList: [],
      form: {
        title: "",
        start_time: "", //活动开始时间
        end_time: "",
        point: "",
        balance: "",
        coupon: ""
      },
      rules: {
        title: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        start_time: [
          { required: true, message: "请输入活动开始时间", trigger: "blur" }
        ]
      },
      // 规则一，活动层级
      // form.give_status: "0",
      // 数字转成汉字
      tranformHanzi: {}
    };
  },
  beforeMount() {
    if (this.$route.query.status != 0) {
      this.initStatus = true;
      console.log("我走这一步", this.$route.query.status);
      this.details();
    }
  },
  methods: {
    // 提交
    submit(formitem) {
      this.$nextTick(() => {
        this.form;
      });
      console.log("提交之前的数据", this.form);
      this.$refs[formitem].validate(valid => {
        if (valid) {
          let data = { ...this.form };
          data.app_id = this.app_id;
          data.token = this.token;
          if (this.jude == 0) {
            addAttention(data).then(res => {
              if (res.code == 200) {
                this.$message.success("保存成功");
                this.$router.go(-1);
              } else {
                this.$message.warning(res.msg);
              }
              console.log("保存", res);
            });
          } else {
            editAttention(data).then(res => {
              if (res.code == 200) {
                this.$message.success("编辑成功");
                this.$router.go(-1);
              } else {
                this.$message.warning(res.msg);
              }
              console.log("保存", res);
              console.log("编辑", res);
            });
          }
          console.log("data", data);
        } else {
          this.$message.warning("请填写必填项！！");
        }
      });
    },
    //选择优惠券
    getCommod(data) {
      console.log("子组件传递数据", data);
      let arrCountId = [];
      data.forEach(item => {
        if (item.choseNum) {
          for (var n = 0; n < Number(item.choseNum); n++) {
            arrCountId.push(item.id);
          }
        }
      });
      this.sList = data;

      this.form.coupon = arrCountId.join(",");
      // this.sList = data;
      this.showSelecter = false;
      console.log("点击", this.form.coupon, this.sList);
    },
    //删除选择的优惠券
    delTagItem(x) {
      console.log(x);
      this.sList.splice(x, 1);
      let j = 0;
      let idArr = [];
      for (j in this.sList) {
        idArr.push(this.sList[j].id);
      }
      this.form.coupon = idArr.join(",");
      console.log("删除", this.form.coupon, this.sList);
    },
    selectCoupon() {
      console.log("选择优惠券");
      this.sList = this.sList;
      this.showSelecter = true;
    },
    details() {
      detailAttention({
        token: this.token,
        app_id: this.app_id,
        id: this.jude
      }).then(res => {
        console.log("vip", res);
        this.form = res.data;
        delete this.form.create_time;
        delete this.form.update_time;
        this.form.start_time = time.setDate(this.form.start_time);
        this.form.end_time = time.setDate(this.form.end_time);
        this.sList = this.form.coupon_list;
        // 优惠券选择数量
        let couponIds = this.form.coupon.split(",");

        let i = 0;
        for (i in this.sList) {
          let dNum = "0";

          for (let d = 0; d < couponIds.length; d++) {
            if (this.sList[i].id == couponIds[d]) {
              dNum++;
            }
          }
          this.sList[i].choseNum = dNum;
          this.sList[i].name = this.sList[i].title;
          this.sList[i].url =
            "https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1576482532.jpg";
        }
        console.log("wef", this.form.rule);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.colorRed {
  color: red;
  padding: 0 6px;
}
.el-form-item {
  margin-bottom: 15px;
}
.content1 {
  border: 1px solid #f1f1f1;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  height: 100%;
  // 上层
  .el-form {
    flex: 1;
    padding: 0 20px 10px 20px;
    overflow-y: auto;
    .box {
      background: #f2f2f6;
      margin-top: 20px;
      padding: 10px;
      border-radius: 6px;
      .title {
        font-weight: 550;
        padding: 10px 0px 10px 20px;
      }
      // 样式
      .fontSize14 {
        font-size: 14px;
      }
      .textAlign {
        text-align: right;
      }
      .color {
        margin: 0px 5px;
        color: #999;
        font-size: 12px;
      }
      .inputMargin {
        width: auto;
        margin: 0 6px;
      }
      .inputWidth {
        height: 30px;
        width: 130px;
      }
      .newInputWidth {
        height: 30px;
        width: 120px;
      }
      .fixedButton {
        width: 70px;
      }
      .width30 {
        width: 30px;
        font-size: 14px;
      }
      .marginBottom10 {
        margin-bottom: 20px;
      }
    }
    // 表格
    .table {
      max-width: 900px;
      border: 1px solid #fff;
      background: #fff;
      height: 100%;
      display: flex;
      border-radius: 6px;
      > div {
        padding: 20px;
      }
      .name {
        font-weight: 550;
        padding: none;
      }
      .table-left {
        width: 220px;
        border-right: 1px solid #f1f1f1;
      }
      .table-right {
        flex: 1;
        .marginBottom {
          margin-bottom: 10px;
        }
        margin-bottom: 10px;
      }
    }
  }
  // 底部
  .bottom {
    border-top: 1px solid #f2f2f6;
    height: 60px;
    line-height: 60px;
    background: #fff;
    text-align: center;
    width: 100%;
    padding: 0 20px;
  }

  .flex {
    display: flex;
    align-items: center;
  }
  .fixedWidth {
    width: 500px;
    .line {
      text-align: center;
    }
  }
  .fixedWidth60 {
    width: 60px;
    padding-right: 6px;
  }
}
</style>
